import { NivaFranTill } from "@/types/anmalan";

export const convertNivaData = (nivaer: NivaFranTill[], displayData: any[]) => {
    if (!displayData.length) {
        return nivaer;
    }
    const data =
        nivaer?.map((niva: NivaFranTill, index: number) => {
            const fran_label = niva.fran ? displayData[index].fran : null;
            const till_label = niva.till ? displayData[index].till : null;
            return {
                fran: { value: niva.fran?.toString() ?? niva.fran, label: fran_label },
                till: { value: niva.till?.toString() ?? niva.till, label: till_label },
            };
        }) || [];
    return data;
};
